// @flow

import type { TaskInstance, TaskInstanceStatus } from '../../common/typings';

import hasAllSubtasksCompleted from './hasAllSubtasksCompleted';

export default function shouldCompleteTask(
  taskInstance: TaskInstance,
  subtaskId: number,
  status: TaskInstanceStatus
): boolean {
  const { subtasks: items = [] } = taskInstance;
  const subtasks = items.map(subtask => {
    if (subtask.id === subtaskId) {
      return {
        ...subtask,
        status
      };
    }
    return subtask;
  });
  return hasAllSubtasksCompleted(subtasks);
}
